import React from 'react'
import CopyText from '../../../components/shared/elements/CopyText'
import { scanningInstructions } from '../../../urls'
import { type Unit } from '../../../store/slices/unitsSlice'

export default function RegulatoryInformation({ currentUnit }: { currentUnit: Unit }): JSX.Element {
    if (String(currentUnit?.attributes?.ManagedBy ?? '').toLowerCase() !== 'agent') {
        return <></>
    }

    return (
        <>
            <div className="my-2 min-w-125px py-3 px-4 w-100 mb-4 row g-0 d-flex flex-row">
                <div className="col-9 fs-5 g-0 d-flex flex-column justify-content-center">
                    <div className="">

                        <div className="mb-2 fs-4 fw-bold counted">
                            is Off Plan ? :
                        </div>
                        <div className="mb-2 fs-4 fw-bold counted">
                            is there Agent Commission ? :
                        </div>
                        <div className='mb-2 fs-4 fw-bold counted'>
                            RERA :
                        </div>
                        <div className="mb-2 fs-4 fw-bold counted">
                            Permit :
                        </div>
                        <div className="mb-2 fs-4 fw-bold counted">
                            Publish end date :
                        </div>

                        <div className="mb-2 fs-4 fw-bold counted">
                            Area :
                        </div>
                    </div>
                </div>
                <div className="col-3 g-0 d-flex flex-column align-items-end ">
                    <div className='mb-2 fs-4 fw-semi-bold counted  text-end'>
                        {currentUnit?.attributes?.Statuses.includes('Off Plan') ? 'Yes' : "No"}</div>
                    <div className='mb-2 fs-4 fw-semi-bold counted'>
                        {currentUnit?.attributes?.Marketing?.AgentCommission != null ? <CopyText text={currentUnit?.attributes?.Marketing?.AgentCommission ?? ''} /> : "No"}
                    </div>
                    <div className='mb-2 fs-4 fw-semi-bold counted'>
                        <CopyText text={currentUnit?.attributes?.RERANumber ?? ""} />
                    </div>
                    <div className='mb-2 fs-4 fw-semi-bold counted'>
                        <CopyText text={currentUnit?.attributes?.PermitNumber ?? ""} />
                    </div>
                    <div className='mb-2 fs-4 fw-semi-bold counted'>
                        <CopyText text={new Date(currentUnit?.attributes?.PublishEndDate ?? "").toDateString()} />
                    </div>

                    <div className='mb-2 fs-4 fw-semi-bold counted  text-end'>
                        <CopyText text={currentUnit?.attributes?.Property?.data.attributes.Area ?? ""} />
                        {/* <div className="mb-2 fs-8 text-end  fw-bold counted">
                            CHANGE
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="p-2 m-2">

                <div className="mb-2 fs-2x text-center fw-bold counted">
                    <a href={currentUnit?.attributes?.PermitLink} target="_blank" rel="noopener noreferrer">
                        Open Trakheesi
                    </a>
                </div>
            </div>

        </>

    )
}
